
<ngb-carousel *ngIf="heroResponse" #carousel appSwipe (swipeLeft)="next()" (swipeRight)="prev()">
    <ng-template ngbSlide *ngFor="let hero of heroResponse.heroes">
        <app-hero-carousel-banner [heroItem]="hero"></app-hero-carousel-banner>
    </ng-template>
</ngb-carousel>

